import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { unique } from '@vestigas/utils';

import { zodContractStatusSchema } from '../validations';

import { CONTRACT_SORT_FIELDS } from './constants';

// Re-export shared validations used by this hook
export {
  zodContractListItemSchema,
  zodContractsListResponseSchema,
} from '../validations';

export const zodContractsQueryParamsSchema = z.object({
  accountingReferenceIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  buyerCompanyId: z.uuid().optional().catch(undefined),
  contractId: z.uuid().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  page: z.coerce.number().int().nonnegative().optional().default(0).catch(0),
  searchString: z.string().trim().optional(),
  sellerCompanyId: z.uuid().optional().catch(undefined),
  siteIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  sortBy: z.enum(CONTRACT_SORT_FIELDS).optional().catch(undefined),
  sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
  status: z.array(zodContractStatusSchema).optional().catch(undefined),
});
